export interface IGridResourceStrings {
    igx_grid_groupByArea_message?: string;
    igx_grid_emptyFilteredGrid_message?: string;
    igx_grid_emptyGrid_message?: string;
    igx_grid_filter?: string;
    igx_grid_filter_row_close?: string;
    igx_grid_filter_row_reset?: string;
    igx_grid_filter_row_placeholder?: string;
    igx_grid_filter_row_boolean_placeholder?: string;
    igx_grid_filter_row_date_placeholder?: string;
    igx_grid_filter_operator_and?: string;
    igx_grid_complex_filter?: string;
    igx_grid_filter_operator_or?: string;
    igx_grid_filter_contains?: string;
    igx_grid_filter_doesNotContain?: string;
    igx_grid_filter_startsWith?: string;
    igx_grid_filter_endsWith?: string;
    igx_grid_filter_equals?: string;
    igx_grid_filter_doesNotEqual?: string;
    igx_grid_filter_empty?: string;
    igx_grid_filter_notEmpty?: string;
    igx_grid_filter_null?: string;
    igx_grid_filter_notNull?: string;
    igx_grid_filter_before?: string;
    igx_grid_filter_after?: string;
    igx_grid_filter_today?: string;
    igx_grid_filter_yesterday?: string;
    igx_grid_filter_thisMonth?: string;
    igx_grid_filter_lastMonth?: string;
    igx_grid_filter_nextMonth?: string;
    igx_grid_filter_thisYear?: string;
    igx_grid_filter_lastYear?: string;
    igx_grid_filter_nextYear?: string;
    igx_grid_filter_greaterThan?: string;
    igx_grid_filter_lessThan?: string;
    igx_grid_filter_greaterThanOrEqualTo?: string;
    igx_grid_filter_lessThanOrEqualTo?: string;
    igx_grid_filter_true?: string;
    igx_grid_filter_false?: string;
    igx_grid_filter_all?: string;
    igx_grid_filter_condition_placeholder?: string;
    igx_grid_summary_count?: string;
    igx_grid_summary_min?: string;
    igx_grid_summary_max?: string;
    igx_grid_summary_sum?: string;
    igx_grid_summary_average?: string;
    igx_grid_summary_earliest?: string;
    igx_grid_summary_latest?: string;
    igx_grid_excel_filter_moving_left?: string;
    igx_grid_excel_filter_moving_left_short?: string;
    igx_grid_excel_filter_moving_right?: string;
    igx_grid_excel_filter_moving_right_short?: string;
    igx_grid_excel_filter_moving_header?: string;
    igx_grid_excel_filter_sorting_asc?: string;
    igx_grid_excel_filter_sorting_asc_short?: string;
    igx_grid_excel_filter_sorting_desc?: string;
    igx_grid_excel_filter_sorting_desc_short?: string;
    igx_grid_excel_filter_sorting_header?: string;
    igx_grid_excel_filter_clear?: string;
    igx_grid_excel_custom_dialog_add?: string;
    igx_grid_excel_custom_dialog_clear?: string;
    igx_grid_excel_custom_dialog_header?: string;
    igx_grid_excel_cancel?: string;
    igx_grid_excel_apply?: string;
    igx_grid_excel_search_placeholder?: string;
    igx_grid_excel_select_all?: string;
    igx_grid_excel_blanks?: string;
    igx_grid_excel_hide?: string;
    igx_grid_excel_show?: string;
    igx_grid_excel_pin?: string;
    igx_grid_excel_unpin?: string;
    igx_grid_excel_text_filter?: string;
    igx_grid_excel_number_filter?: string;
    igx_grid_excel_date_filter?: string;
    igx_grid_excel_boolean_filter?: string;
    igx_grid_excel_custom_filter?: string;
    igx_grid_advanced_filter_title?: string;
    igx_grid_advanced_filter_and_group?: string;
    igx_grid_advanced_filter_or_group?: string;
    igx_grid_advanced_filter_end_group?: string;
    igx_grid_advanced_filter_create_and_group?: string;
    igx_grid_advanced_filter_create_or_group?: string;
    igx_grid_advanced_filter_and_label?: string;
    igx_grid_advanced_filter_or_label?: string;
    igx_grid_advanced_filter_add_condition?: string;
    igx_grid_advanced_filter_ungroup?: string;
    igx_grid_advanced_filter_delete?: string;
    igx_grid_advanced_filter_delete_filters?: string;
    igx_grid_advanced_filter_initial_text?: string;
    igx_grid_advanced_filter_column_placeholder?: string;
    igx_grid_advanced_filter_value_placeholder?: string;
}

export const GridResourceStringsEN: IGridResourceStrings = {
    igx_grid_groupByArea_message: 'Drag a column header and drop it here to group by that column.',
    igx_grid_emptyFilteredGrid_message: 'No records found.',
    igx_grid_emptyGrid_message: 'Grid has no data.',
    igx_grid_filter: 'Filter',
    igx_grid_filter_row_close: 'Close',
    igx_grid_filter_row_reset: 'Reset',
    igx_grid_filter_row_placeholder: 'Add filter value',
    igx_grid_filter_row_boolean_placeholder: 'All',
    igx_grid_filter_row_date_placeholder: 'Pick up date',
    igx_grid_filter_operator_and: 'And',
    igx_grid_filter_operator_or: 'Or',
    igx_grid_complex_filter: 'Complex Filter',
    igx_grid_filter_contains: 'Contains',
    igx_grid_filter_doesNotContain: 'Does Not Contain',
    igx_grid_filter_startsWith: 'Starts With',
    igx_grid_filter_endsWith: 'Ends With',
    igx_grid_filter_equals: 'Equals',
    igx_grid_filter_doesNotEqual: 'Does Not Equal',
    igx_grid_filter_empty: 'Empty',
    igx_grid_filter_notEmpty: 'Not Empty',
    igx_grid_filter_null: 'Null',
    igx_grid_filter_notNull: 'Not Null',
    igx_grid_filter_before: 'Before',
    igx_grid_filter_after: 'After',
    igx_grid_filter_today: 'Today',
    igx_grid_filter_yesterday: 'Yesterday',
    igx_grid_filter_thisMonth: 'This Month',
    igx_grid_filter_lastMonth: 'Last Month',
    igx_grid_filter_nextMonth: 'Next Month',
    igx_grid_filter_thisYear: 'This Year',
    igx_grid_filter_lastYear: 'Last Year',
    igx_grid_filter_nextYear: 'Next Year',
    igx_grid_filter_greaterThan: 'Greater Than',
    igx_grid_filter_lessThan: 'Less Than',
    igx_grid_filter_greaterThanOrEqualTo: 'Greater Than Or Equal To',
    igx_grid_filter_lessThanOrEqualTo: 'Less Than Or Equal To',
    igx_grid_filter_true: 'True',
    igx_grid_filter_false: 'False',
    igx_grid_filter_all: 'All',
    igx_grid_filter_condition_placeholder: 'Select filter',
    igx_grid_summary_count: 'Count',
    igx_grid_summary_min: 'Min',
    igx_grid_summary_max: 'Max',
    igx_grid_summary_sum: 'Sum',
    igx_grid_summary_average: 'Avg',
    igx_grid_summary_earliest: 'Earliest',
    igx_grid_summary_latest: 'Latest',
    igx_grid_excel_filter_moving_left: 'move left',
    igx_grid_excel_filter_moving_left_short: 'left',
    igx_grid_excel_filter_moving_right: 'move right',
    igx_grid_excel_filter_moving_right_short: 'right',
    igx_grid_excel_filter_moving_header: 'move',
    igx_grid_excel_filter_sorting_asc: 'ascending',
    igx_grid_excel_filter_sorting_asc_short: 'asc',
    igx_grid_excel_filter_sorting_desc: 'descending',
    igx_grid_excel_filter_sorting_desc_short: 'desc',
    igx_grid_excel_filter_sorting_header: 'sort',
    igx_grid_excel_filter_clear: 'Clear column filters',
    igx_grid_excel_custom_dialog_add: 'add filter',
    igx_grid_excel_custom_dialog_clear: 'Clear filter',
    igx_grid_excel_custom_dialog_header: 'Custom auto-filter on column: ',
    igx_grid_excel_cancel: 'cancel',
    igx_grid_excel_apply: 'apply',
    igx_grid_excel_search_placeholder: 'Search',
    igx_grid_excel_select_all: 'Select All',
    igx_grid_excel_blanks: '(Blanks)',
    igx_grid_excel_hide: 'Hide column',
    igx_grid_excel_show: 'Show column',
    igx_grid_excel_pin: 'Pin column',
    igx_grid_excel_unpin: 'Unpin column',
    igx_grid_excel_text_filter: 'Text filter',
    igx_grid_excel_number_filter: 'Number filter',
    igx_grid_excel_date_filter: 'Date filter',
    igx_grid_excel_boolean_filter: 'Boolean filter',
    igx_grid_excel_custom_filter: 'Custom filter...',
    igx_grid_advanced_filter_title: 'Advanced Filtering',
    igx_grid_advanced_filter_and_group: '"And" Group',
    igx_grid_advanced_filter_or_group: '"Or" Group',
    igx_grid_advanced_filter_end_group: 'End Group',
    igx_grid_advanced_filter_create_and_group: 'Create "And" Group',
    igx_grid_advanced_filter_create_or_group: 'Create "Or" Group',
    igx_grid_advanced_filter_and_label: 'and',
    igx_grid_advanced_filter_or_label: 'or',
    igx_grid_advanced_filter_add_condition: 'Condition',
    igx_grid_advanced_filter_ungroup: 'Ungroup',
    igx_grid_advanced_filter_delete: 'Delete',
    igx_grid_advanced_filter_delete_filters: 'Delete filters',
    igx_grid_advanced_filter_initial_text: 'Start with creating a group of conditions linked with "And" or "Or"',
    igx_grid_advanced_filter_column_placeholder: 'Select column',
    igx_grid_advanced_filter_value_placeholder: 'Value'
};
